import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import Select from 'react-select';

export default function VendorEdit() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const [activeTab, setActiveSection] = useState("companyInfo");
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap campaign-section">
            <nav className="breadcrumb" aria-label="breadcrumb">
              <ol>
                <li className="breadcrumb-item active" aria-current="page">
                  {translate("home")}
                </li>
              </ol>
            </nav>
            <div className="white-bg mh-550 mar-bot50">
              <div className="vender-edit-page">
                <div className="vender-heading">
                  <h4>Edit Company Profile</h4>
                </div>
                <div className="listing-tab-block flex">
                    <ul className="listing-tab-link flex" role="tablist">
                        <li role="none"><button
                           className={activeTab === "companyInfo" ? "active" : ""}
                           role="tab"
                           aria-label={activeTab === "companyInfo" ? "Current tab, Company’s Info" : "Company’s Info"}
                           aria-selected={activeTab === "companyInfo" ? "true" : "false"}
                           onClick={() => setActiveSection("companyInfo")}
                          >Company’s Info</button></li>
                        <li role="none"><button
                           className={activeTab === "contactInfo" ? "active" : ""}
                           role="tab"
                           aria-label={activeTab === "contactInfo" ? "Current tab, Contact Information" : "Contact Information"}
                           aria-selected={activeTab === "contactInfo" ? "true" : "false"}
                           onClick={() => setActiveSection("contactInfo")}
                         
                        >Contact Information</button></li>
                        <li role="none"><button
                          className={activeTab === "vendorsocials" ? "active" : ""}
                          role="tab"
                          aria-label={activeTab === "vendorsocials" ? "Current tab, Socials" : "Socials"}
                          aria-selected={activeTab === "vendorsocials" ? "true" : "false"}
                          onClick={() => setActiveSection("vendorsocials")}
                        >Socials</button></li>
                    </ul>
                </div>
                <div className="inner-container input-text-container mar-bot30">
                   <div className={activeTab === "companyInfo" ? "companyInfo-tab-content show" : "hide"}>
                       <div className="flex wrap-dropdown">
                          <div className="global-dropdown-block">
                              <label>Name</label>
                              <input type="text" className="form-control-sm" placeholder="Enter Company Name" />
                          </div>
                          <div className="global-dropdown-block">
                              <label>Last Name <span>Optional</span></label>
                              <input type="text" className="form-control-sm" placeholder="Enter Your Last Name" />
                          </div>
                        </div>
                        <div className="flex wrap-dropdown">
                          <div className="global-dropdown-block max-width">
                              <label>About Us</label>
                              <textarea className="textarea" placeholder="2000 character limit"></textarea>
                          </div>
                       </div>
                        <div className="flex wrap-dropdown">
                          <div className="global-dropdown-block flex-center">
                              <label>Certification <span>Optional</span></label>
                              <Select classNamePrefix='cw'
                                className="global-dropdown-select"
                                defaultValue={{ label: 'You can select multiple certifications' }}
                                menuShouldScrollIntoView={false}
                              />
                              <div className="multiselect-output flex">
                                <button>
                                  <strong>French</strong>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                                  <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                  </svg>
                                </button>
                                <button>
                                  <strong>AMSDS Certified (Canada)</strong>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                                  <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                  </svg>
                                </button>
                              </div>
                          </div>
                          <div className="global-dropdown-block flex-center">
                              <label>Industries</label>
                              <Select classNamePrefix='cw'
                                className="global-dropdown-select"
                                defaultValue={{ label: 'You can select multiple industries' }}
                                menuShouldScrollIntoView={false}
                              />
                              <div className="multiselect-output flex">
                                <button>
                                  <strong>French</strong>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                                  <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                  </svg>
                                </button>
                                <button>
                                  <strong>AMSDS Certified (Canada)</strong>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                                  <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                  </svg>
                                </button>
                              </div>
                          </div>
                        </div>
                        <div className="flex wrap-dropdown">
                         <div className="global-dropdown-block flex-center">
                              <label>Supported File Type <span>Optional</span></label>
                              <Select classNamePrefix='cw'
                                className="global-dropdown-select"
                                defaultValue={{ label: 'You can select multiple file type' }}
                                menuShouldScrollIntoView={false}
                              />
                              <div className="multiselect-output flex">
                                <button>
                                  <strong>French</strong>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                                  <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                  </svg>
                                </button>
                                <button>
                                  <strong>AMSDS Certified (Canada)</strong>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                                  <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                  </svg>
                                </button>
                              </div>
                          </div>
                        </div>
                        <div className="group-checkbox flex mar-bot30">
                          <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="checkbox" value="" id="chk1" />
                            <label className="form-check-label" for="chk1">Generate Preview ZIP</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="checkbox" value="" id="chk2" />
                            <label className="form-check-label" for="chk2">Notify on Assets  Approval</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="checkbox" value="" id="chk3" />
                            <label className="form-check-label" for="chk3">Notify on Language Approval</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="checkbox" value="" id="chk4" />
                            <label className="form-check-label" for="chk4">Notify on Project Approval</label>
                          </div>
                        </div>
                   </div>
                   <div className={activeTab === "contactInfo" ? "contactInfo-tab-content show" : "hide"}>
                   <div className="flex wrap-dropdown">
                          <div className="global-dropdown-block">
                              <label>Email ID </label>
                              <input type="text" className="form-control-sm" placeholder="Enter Your Email ID " />
                          </div>
                          <div className="global-dropdown-block">
                              <label>First Name</label>
                              <input type="text" className="form-control-sm" placeholder="Enter Your First Name" />
                          </div>
                        </div>
                        <div className="flex wrap-dropdown">
                          <div className="global-dropdown-block">
                              <label>Last Name </label>
                              <input type="text" className="form-control-sm" placeholder="Enter your last name " />
                          </div>
                          <div className="global-dropdown-block">
                              <label>Company Phone</label>
                              <input type="text" className="form-control-sm" placeholder="Enter Your Company’s Phone Number" />
                          </div>
                        </div>
                        <div className="flex wrap-dropdown">
                          <div className="global-dropdown-block">
                              <label>Street</label>
                              <input type="text" className="form-control-sm" placeholder="Add Street Name" />
                          </div>
                          <div className="global-dropdown-block">
                              <label>Floor / Suite <span>Optional</span></label>
                              <input type="text" className="form-control-sm" placeholder="Add the Floor Name / Suite Number" />
                          </div>
                        </div>
                        <div className="flex wrap-dropdown">
                          <div className="global-dropdown-block">
                              <label>City</label>
                              <input type="text" className="form-control-sm" placeholder="Enter Your City" />
                          </div>
                          <div className="global-dropdown-block">
                              <label>State</label>
                              <input type="text" className="form-control-sm" placeholder="Add State" />
                          </div>
                        </div>
                        <div className="flex wrap-dropdown">
                          <div className="global-dropdown-block">
                              <label>ZIP Code <span>Optional</span></label>
                              <input type="text" className="form-control-sm" placeholder="Add ZIP Code" />
                          </div>
                          <div className="global-dropdown-block">
                              <label>Country</label>
                              <input type="text" className="form-control-sm" placeholder="Enter your Country" />
                          </div>
                        </div>
                   </div>
                   <div className={activeTab === "vendorsocials" ? "vendorsocials-tab-content show" : "hide"}>
                   <div className="flex wrap-dropdown">
                      <div className="global-dropdown-block">
                          <label>Website <span>Optional</span></label>
                          <input type="text" className="form-control-sm" placeholder="Enter Your Website" />
                      </div>
                      <div className="global-dropdown-block">
                          <label>Twitter Account <span>Optional</span></label>
                          <input type="text" className="form-control-sm" placeholder="Add your Twitter Account Link" />
                      </div>
                    </div>
                    <div className="flex wrap-dropdown">
                      <div className="global-dropdown-block">
                          <label>Facebook Account <span>Optional</span></label>
                          <input type="text" className="form-control-sm" placeholder="Add your Facebook Account Link" />
                      </div>
                    </div>
                   </div>
                </div>
              </div>
        
            </div>
          </div>
        </section>
      </div>
      <div className="stricy-btn flex flex-center no-rightlist">
        <div className="left flex">
            
        </div>
        <div className="left flex">
            <div>
            <button className="btn-default">Cancel</button>
            </div>
            <div>
            <button className="btn-default">Save</button>
            </div>
        </div>
     </div>
    </div>
  );
}
